import { Component, OnInit, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalSaveService } from '../../services/local-save-service.service';
import { AppServiceService } from '../../services/app-service.service';
import { GatewayService } from 'src/app/gateway.service';
import { ClienteinfoService } from 'src/app/services/clienteinfo.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-agendar-calendar',
  templateUrl: './agendar-calendar.component.html',
  styleUrls: ['./agendar-calendar.component.scss']
})
export class AgendarCalendarComponent implements OnInit {

  public queuestr;
  public sanitizeurl;
  public callstate = 0;
  public userdata;
  // public companynumber='12104057490';
  // private baseurl = 'https://pre-gina.wex.services'
  public companynumber = '';
  private baseurl = environment.wexBaseUrl;

  @Input() phone: number;
  @Output() refreshurl;

  constructor(
    public _sanitizer: DomSanitizer,
    public localsave: LocalSaveService,
    public appservice: AppServiceService,
    private gateway: GatewayService,
    private clienteinfo: ClienteinfoService,
  ) { }

  ngOnInit(): void {
    this.localsave.set('callstate', 0);
    this.queuestr = 'cobase';
    // let phonearea = `50255899718`;
    // info del usuario/agente
    let value: string = this.localsave.get('usuarioPGV').idagente;
    // alert(value)
    this.userdata = { ID: value };
    // info del usuario/agente
    // this.sanitizeurl = this._sanitizer.bypassSecurityTrustResourceUrl(`https://pre-gina.wex.services/?idagente=${this.userdata.ID}&queue=${queuestr}&type=outbound&To=${507+''+this.phone}&From=${this.companynumber}`);
    this.sanitizeurl = this._sanitizer.bypassSecurityTrustResourceUrl(`${environment.baseUrlPGViFrame}/calendar?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZF9jb250cmF0YSI6MSwiaWRfY2xpZW50ZSI6MSwiaWRfdXN1YXJpbyI6MSwiaWRfY2FzbyI6MSwiZGlyZWNjaW9uIjoiQ2FsbGUgMTIzIiwiY29kX2N1ZW50YSI6IjEyMzQ1NiJ9.380JjFAZiA4gAPv0urdP3WPRPhQstMDqlquIOJ_h6ok`);
    this.localsave.sanitizeurl1 = this.sanitizeurl;

    window.addEventListener('message', (event: any) => {
      if (event.origin === this.baseurl) {
        if (event.data.EVENTO === 'call-end') {
          //llamamos la función para minimizar iframe y reiniciar componente de llamada      
          this.minimizarllamada(1);
        }
      }
    });

  }

  modificarUrl() {
    // this.sanitizeurl = this._sanitizer.bypassSecurityTrustResourceUrl(`https://ginacr.wex.services/?idagente=${this.userdata.ID}&queue=${this.queuestr}&tipo=outbound&To=${507 + '' + this.localsave.get('consent_telefono')}&From=${this.companynumber}&env=3&idcaso=${this.localsave.get('objwexllamadas')}`);
    // this.localsave.sanitizeurl = this.sanitizeurl;
    // this.gateway.get('insert_datos_idcaso_wex', {
    //   proceso: 1,
    //   idcaso: this.localsave.get('objwexllamadas'),
    //   idblaster: this.clienteinfo.getcliente().cliente.idblaster,
    //   phone_number: this.clienteinfo.getcliente().cliente.telefono,
    //   cc_campaign_id: this.clienteinfo.getcliente().cliente.idcampana,
    //   account_id: this.clienteinfo.getcliente().cliente.account_id,
    //   communication_id: this.clienteinfo.getcliente().cliente.communication_id,
    //   campania_cc: this.clienteinfo.getcliente().cliente.nombrecampana,
    //   idcliente: this.clienteinfo.getcliente().cliente.idcliente,
    //   idfeedbackcc: this.clienteinfo.getcliente().cliente.idfeedbackcc
    // }).then((result: any) => { }).catch();
  }

  public maximizarllamada() {
    this.callstate = 1;
    this.localsave.set('callstate', 1);
    if (this.localsave.get('consent_telefono'))
      this.modificarUrl();
  }

  public minimizarllamada(tipo?) {
    this.callstate = 0;
    this.localsave.set('callstate', 0);
    if (tipo === 1) {
      // refrescamos la url para dejar lista por si nueva llamada
      setTimeout(() => {
        (<HTMLIFrameElement>document.getElementById("iframewex")).src += '';
      }, 250);
    }
  }

}
